export const PAYEE_PRODUCT_TYPE_TICKET = "TICKET"
export const PAYEE_PRODUCT_TYPE_SERVICE = "SERVICE"
export const PAYEE_PRODUCT_TYPE_PHYSICAL = "PHYSICAL"
export const PAYEE_PRODUCT_TYPE_DIGITAL = "DIGITAL"
export const PAYEE_PRODUCT_TYPE_RENTAL = "RENTAL"